import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import Translate from '@hydra/common/components/i18n';
import ProgressBar from '@hydra/common/components/ProgressBar';
import Criterium from '@hydra/common/criterium/Criterium';
import { getContrastedColor, getPriSecColors } from '@hydra/utils/colors';
import { useReviewContext } from '@hydra/common/context/review';
import { usePdfTemplateContext } from '@hydra/common/context/pdfTemplate';

const useStyles = makeStyles(theme => ({
  text: {
    marginBottom: theme.spacing(1)
  }
}));

const getProgressText = score => {
  const texts = [
    { treshold: 0.15, component: <Translate content='progress_very_bad' /> },
    { treshold: 0.3, component: <Translate content='progress_bad' /> },
    { treshold: 0.6, component: <Translate content='progress_average' /> },
    { treshold: 0.8, component: <Translate content='progress_good' /> },
    { treshold: Infinity, component: <Translate content='progress_very_good' /> }
  ];

  const text = texts.find(text => text.treshold > score);
  return text ? text.component : null;
};

export const MobileFriendliness = ({ criterium }) => {
  const classes = useStyles();
  const { isPdf } = useReviewContext();
  const { templateColors } = usePdfTemplateContext();
  const { primary } = isPdf
    ? templateColors
    : getPriSecColors();
  const color = getContrastedColor(primary);
  const { score, url } = criterium;

  const textContent = score >= 0.6
    ? 'mob_opt_2'
    : 'mob_opt_0';

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url, url }}
    >
      <div className={classes.text}>
        {getProgressText(score)}
      </div>
      <div className={classes.text}>
        <ProgressBar value={score} color={color} max={1} />
      </div>
      <Translate content={textContent} component='div' />
    </Criterium>
  );
};

MobileFriendliness.propTypes = {
  criterium: PropTypes.shape({
    score: PropTypes.number
  })
};

export default React.memo(MobileFriendliness);
